import React, { useRef, useState } from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';
import axios from 'axios';
import { API } from '../../../controller/api';
import { v4 as uuidv4 } from 'uuid';
import { Delete } from '@mui/icons-material';
function FileUploader(props) {
  const [text, setText] = useState('');
  const fileInputRef = useRef(null); // Create a ref for the file input
  const [fileName, setFileName] = useState('');

  const handleFileChange = async (event) => {
    const selectedFile = event.target.files[0];
    
    if (!selectedFile) {
      clearFile();
      return;
    }
  
    // Update fileName immediately
    setFileName(selectedFile.name);
  
    if (selectedFile.name.toLowerCase().includes('docx')) {
      try {
        const formData = new FormData();
        formData.append('docx', selectedFile);
  
        const response = await fetch(API + '/resume-reviewer/convert-to-text', {
          method: 'POST',
          body: formData,
        });
  
        if (response.ok) {
          const extractedText = await response.text();
          props.SetText({
            id: uuidv4(),
            text: extractedText,
            fileName: selectedFile.name,
          });
        } else {
          console.error('Error converting DOCX to text:', response.status);
        }
      } catch (error) {
        console.error('Error converting DOCX to text:', error);
      }
    } else if (selectedFile.name.toLowerCase().includes('pdf')) {
      try {
        const formData = new FormData();
        formData.append('file', selectedFile);
  
        const response = await axios.post(API + '/resume-reviewer/pdf-to-text', formData);
        const textContent = response.data;
  
        props.SetText({
          id: uuidv4(),
          text: textContent,
          fileName: selectedFile.name,
        });
      } catch (error) {
        console.error('Error uploading PDF:', error);
      }
    } else {
      console.error('Unsupported file format.');
    }
  };
  

  const clearFile = () => {
    setFileName(''); // Clear file name
    if (fileInputRef.current) {
      fileInputRef.current.value = ''; // Clear file input
    }
  };


  return (
    <div>
    <InputGroup >
      {/* Hidden file input */}
      <Form.Control
        type="file"
        accept=".pdf,.docx"
        onChange={handleFileChange}
        ref={fileInputRef}
        style={{ display: 'none' }}
      />

      {/* Select File Button */}
      {fileName === '' && (
      <Button
       variant="secondary"
       style={{borderTopLeftRadius: '0.25rem', borderBottomLeftRadius: '0.25rem'}}
        onClick={() => fileInputRef.current && fileInputRef.current.click()}
      >
        Select File
      </Button>
            )}

      {/* Display File Name with Clear Option */}
      {fileName !== '' && (
        <>
          <Form.Control
          disabled
          value={fileName}
          />
         
          <Button
            variant="danger"
            size="sm"
     
            onClick={clearFile}
          >
            <Delete/>
          </Button>
        </>
      )}

      {/* Upload Button */}
      <Button
        variant="primary"
        onClick={()=>{props.handleAdd(); clearFile();}}
        
      >
        Upload
      </Button>
    </InputGroup>
  </div>
  );
}

export default FileUploader;
